import * as React from "react";
import type { SVGProps } from "react";
const SvgLockOpen01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.6 8.8v-.914C6.6 4.846 9.009 2.4 12 2.4c1.863 0 3.5.95 4.47 2.4m-9.87 4c-.99 0-1.8.823-1.8 1.829v9.142c0 1.006.81 1.829 1.8 1.829h10.8c.99 0 1.8-.823 1.8-1.829V10.63c0-1.006-.81-1.829-1.8-1.829zm5.4 4.571c.99 0 1.8.823 1.8 1.829s-.81 1.829-1.8 1.829-1.8-.823-1.8-1.829.81-1.829 1.8-1.829Z"
    />
  </svg>
);
export default SvgLockOpen01;
